"use client";

import { ReactNode } from "react";
import { Toaster } from "sonner";
import TopBanner from "@/components/layout/top-banner";
import Navbar from "@/components/layout/navbar";
import Footer from "@/components/layout/footer";

interface PublicLayoutViewProps {
  children: ReactNode;
}

export default function PublicLayoutView({ children }: PublicLayoutViewProps) {
  return (
    <div className="min-h-screen bg-background-100 overflow-x-hidden">
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            fontFamily: "var(--font-plus-jakarta-sans)",
          },
          classNames: {
            error: "!bg-error !text-white !border-error",
            success: "!bg-success !text-white !border-success",
            warning: "!bg-warning !text-black !border-warning",
          },
        }}
      />
      <TopBanner />
      <Navbar />
      {children}
      <Footer />
    </div>
  );
}
